var _g, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocketOrbit = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 17,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_763_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69471 12.0656C1.13597 9.73594 0.950206 5.77312 3.2792 3.21438C5.25044 1.04949 8.45838 0.53814 11.0046 1.98293",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49765 12.021C0.701407 13.4159 0.434899 14.4983 0.884549 14.9486C1.56723 15.6307 3.70323 14.6664 6.17663 12.705",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00756 12.2094L6.65756 9.8594L11.8807 4.63624C12.3067 4.21022 12.8404 3.90827 13.4253 3.7632L14.769 3.4258C15.0657 3.35162 15.3663 3.53279 15.4405 3.8295C15.4622 3.91746 15.4622 4.00936 15.4405 4.09732L15.1044 5.44167C14.9587 6.02589 14.6561 6.55956 14.2301 6.98558L9.00756 12.2094Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6582 9.85938L4.73356 9.21806C4.58849 9.17014 4.50972 9.01325 4.55764 8.86818C4.57143 8.82683 4.5944 8.78941 4.62525 8.75856L5.29612 8.0877C5.89084 7.49298 6.77045 7.28555 7.56866 7.5514L8.61893 7.90062L6.6582 9.85938Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00781 12.2093L9.64914 14.1346C9.69706 14.2797 9.85394 14.3585 9.99901 14.3106C10.0404 14.2968 10.0778 14.2738 10.1086 14.2429L10.7795 13.5721C11.3742 12.9774 11.5816 12.0978 11.3158 11.2995L10.9666 10.2493L9.00781 12.2093Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 17,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: fill,
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_763_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69471 12.0656C1.13597 9.73594 0.950206 5.77312 3.2792 3.21438C5.25044 1.04949 8.45838 0.53814 11.0046 1.98293",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49765 12.021C0.701407 13.4159 0.434899 14.4983 0.884549 14.9486C1.56723 15.6307 3.70323 14.6664 6.17663 12.705",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00756 12.2094L6.65756 9.8594L11.8807 4.63624C12.3067 4.21022 12.8404 3.90827 13.4253 3.7632L14.769 3.4258C15.0657 3.35162 15.3663 3.53279 15.4405 3.8295C15.4622 3.91746 15.4622 4.00936 15.4405 4.09732L15.1044 5.44167C14.9587 6.02589 14.6561 6.55956 14.2301 6.98558L9.00756 12.2094Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6582 9.85938L4.73356 9.21806C4.58849 9.17014 4.50972 9.01325 4.55764 8.86818C4.57143 8.82683 4.5944 8.78941 4.62525 8.75856L5.29612 8.0877C5.89084 7.49298 6.77045 7.28555 7.56866 7.5514L8.61893 7.90062L6.6582 9.85938Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00781 12.2093L9.64914 14.1346C9.69706 14.2797 9.85394 14.3585 9.99901 14.3106C10.0404 14.2968 10.0778 14.2738 10.1086 14.2429L10.7795 13.5721C11.3742 12.9774 11.5816 12.0978 11.3158 11.2995L10.9666 10.2493L9.00781 12.2093Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
});
export default SvgIconRocketOrbit;
export const raw = __webpack_public_path__ + "static/media/icon-rocket-orbit.ef5c2c25b3598fd4994014833414ab33.svg";